// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"216":"aca255a0","825":"7fa5fc1e"}[chunkId] + ".chunk.js");